// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IPlanYearPlanDto
 */
export interface IPlanYearPlanDto {
    /**
     * 
     * @type {number}
     * @memberof IPlanYearPlanDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof IPlanYearPlanDto
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof IPlanYearPlanDto
     */
    max_election_amount?: number;
    /**
     * 
     * @type {number}
     * @memberof IPlanYearPlanDto
     */
    min_election_amount?: number;
    /**
     * 
     * @type {number}
     * @memberof IPlanYearPlanDto
     */
    per_person_spend_limit_amount?: number;
    /**
     * 
     * @type {boolean}
     * @memberof IPlanYearPlanDto
     */
    can_set_health_plan_spend_limits?: boolean;
}

/**
 * Check if a given object implements the IPlanYearPlanDto interface.
 */
export function instanceOfIPlanYearPlanDto(value: object): value is IPlanYearPlanDto {
    return true;
}

export function IPlanYearPlanDtoFromJSON(json: any): IPlanYearPlanDto {
    return IPlanYearPlanDtoFromJSONTyped(json, false);
}

export function IPlanYearPlanDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IPlanYearPlanDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'max_election_amount': json['max_election_amount'] == null ? undefined : json['max_election_amount'],
        'min_election_amount': json['min_election_amount'] == null ? undefined : json['min_election_amount'],
        'per_person_spend_limit_amount': json['per_person_spend_limit_amount'] == null ? undefined : json['per_person_spend_limit_amount'],
        'can_set_health_plan_spend_limits': json['can_set_health_plan_spend_limits'] == null ? undefined : json['can_set_health_plan_spend_limits'],
    };
}

export function IPlanYearPlanDtoToJSON(json: any): IPlanYearPlanDto {
    return IPlanYearPlanDtoToJSONTyped(json, false);
}

export function IPlanYearPlanDtoToJSONTyped(value?: IPlanYearPlanDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'max_election_amount': value['max_election_amount'],
        'min_election_amount': value['min_election_amount'],
        'per_person_spend_limit_amount': value['per_person_spend_limit_amount'],
        'can_set_health_plan_spend_limits': value['can_set_health_plan_spend_limits'],
    };
}

